export default __webpack_public_path__ + "static/media/keyFeature_2.46aee821.svg";